import _ from "lodash";
import {PREFERENCES_SET} from "../actions/actionTypes/";

const PreferencesReducer = (state = {lang: ""}, action) => {
    var ret = _.cloneDeep(state);
    switch (action.type) {
        case PREFERENCES_SET:
            ret[action.key] = action.value;
            return ret;
        default :
            return state;
    }
};

export default PreferencesReducer;